import { instance } from '@/services/avik-api-gateway'
import { Statusbar } from '@/types/statusbar'
import { AxiosResponse } from 'axios'

export function createStatusbar(
  body: Statusbar
): Promise<AxiosResponse<Statusbar>> {
  return instance.post(`/notification`, body)
}
